import { generateRandomID } from "../../../helpers/utilities";
import { textChooser } from "../../../util/textChooser";
import { ControlWrapper } from "../common";
import { InputCommon, InputControl } from ".";
import "./fieldFile.scss";

interface FieldFileProps extends InputCommon { }

export const FieldFile = (props: FieldFileProps) => {
  const randomId = generateRandomID();

  return (
    <ControlWrapper label={props.label} subLabel={props.subLabel} testId={props.testId} id={randomId}>
      <div className={`field-file-wrapper`}>
        <i className="file-text">
          {textChooser("txt139")}
        </i>
        <InputControl
          {...props}
          type="file"
          className="file"
          placeholder={textChooser("txt139")}
          randomId={randomId}
        />
      </div>
    </ControlWrapper>
  )
}